/* =========================================================
   NUOVA TECH — theme.js (vanilla, sans dépendance)
   ========================================================= */
(function () {
  'use strict';

  var T = window.theme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var ICONS = {
    fire: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22c4 0 7-3 7-7 0-5-4-7-5-11-2 2-3 4-3 6-1-1-2-2-2-4-2 2-4 5-4 9 0 4 3 7 7 7z"/></svg>',
    close: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    minus: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    trash: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 15h10l1-15"/></svg>',
    truck: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 4h14v12H1z"/><path d="M15 9h4l4 4v3h-8"/><circle cx="6" cy="18.5" r="2"/><circle cx="18" cy="18.5" r="2"/></svg>',
    cart: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h15l-1.5 9h-12z"/><path d="M6 7 5 3H2"/><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/></svg>'
  };

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = (format || T.moneyFormat || '{{amount_with_comma_separator}} €').replace(/<[^>]*>/g, '');
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, precision, thousands, decimal) {
      if (n == null || isNaN(n)) return '0';
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(re);
    if (!m) return format;
    var v;
    switch (m[1]) {
      case 'amount': v = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2, '.', ',');
    }
    return format.replace(re, v);
  }
  T.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Drawers ---------- */
  function openDrawer(drawer, overlay) {
    if (!drawer) return;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    setTimeout(function () { drawer.focus(); }, 50);
  }
  function closeDrawer(drawer, overlay) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    setTimeout(function () { overlay.hidden = true; }, 250);
    document.body.classList.remove('is-locked');
  }

  function initMenu() {
    var drawer = $('[data-menu-drawer]');
    var overlay = $('[data-menu-overlay]');
    if (!drawer || !overlay) return;
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { openDrawer(drawer, overlay); }); });
    $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer(drawer, overlay); }); });
    overlay.addEventListener('click', function () { closeDrawer(drawer, overlay); });
  }

  /* ---------- Cart ---------- */
  var cartDrawer, cartOverlay;

  function getCart() {
    return fetch((T.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCounts(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (el.classList.contains('header__cart-count')) el.hidden = count === 0;
    });
  }

  function shippingHtml(cart) {
    var th = Number(T.freeShipping) || 0;
    if (cart.item_count === 0) return '';
    if (th <= 0) return '<span style="display:flex;gap:8px;align-items:center">' + ICONS.truck + 'Livraison offerte sur votre commande</span>';
    var left = th - cart.total_price;
    if (left <= 0) return '<span style="display:flex;gap:8px;align-items:center">' + ICONS.truck + 'Bravo, la livraison est offerte !</span><span class="stockbar stockbar--sm"><span style="width:100%"></span></span>';
    var pct = Math.min(100, Math.round((cart.total_price / th) * 100));
    return '<span>Plus que <strong>' + esc(formatMoney(left)) + '</strong> pour la livraison offerte</span><span class="stockbar stockbar--sm"><span style="width:' + pct + '%"></span></span>';
  }

  function renderCart(cart) {
    updateCounts(cart.item_count);
    if (!cartDrawer) return;
    var items = $('[data-cart-items]', cartDrawer);
    var ship = $('[data-cart-ship]', cartDrawer);
    var total = $('[data-cart-total]', cartDrawer);
    var savings = $('[data-cart-savings]', cartDrawer);

    cartDrawer.classList.toggle('is-empty', cart.item_count === 0);
    ship.innerHTML = shippingHtml(cart);
    total.textContent = formatMoney(cart.total_price);

    if (cart.total_discount > 0) {
      savings.hidden = false;
      savings.textContent = 'Remise appliquée : -' + formatMoney(cart.total_discount);
    } else {
      savings.hidden = true;
    }

    if (cart.item_count === 0) {
      items.innerHTML = '<div class="cart-drawer__empty">' + ICONS.cart + '<span>' + esc(T.strings.empty) + '</span><a href="' + (T.routes.root || '/') + 'collections/all" class="btn btn--accent">Voir les bonnes affaires</a></div>';
      return;
    }

    items.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var variant = item.product_has_only_default_variant ? '' : (item.variant_title || '');
      var was = item.original_line_price > item.final_line_price ? '<s>' + esc(formatMoney(item.original_line_price)) + '</s>' : '';
      return '' +
        '<div class="cart-item" data-key="' + esc(item.key) + '">' +
          '<a href="' + esc(item.url) + '">' + (img ? '<img class="cart-item__img" src="' + esc(img) + '" alt="" loading="lazy" width="76" height="76">' : '<span class="cart-item__img"></span>') + '</a>' +
          '<div>' +
            '<a href="' + esc(item.url) + '" class="cart-item__title">' + esc(item.product_title) + '</a>' +
            (variant ? '<p class="cart-item__variant">' + esc(variant) + '</p>' : '<p class="cart-item__variant"></p>') +
            '<div class="cart-item__row">' +
              '<div class="qty qty--sm">' +
                '<button type="button" data-change="' + (item.quantity - 1) + '" aria-label="Diminuer">' + ICONS.minus + '</button>' +
                '<input type="number" value="' + item.quantity + '" min="0" aria-label="Quantité" data-change-input>' +
                '<button type="button" data-change="' + (item.quantity + 1) + '" aria-label="Augmenter">' + ICONS.plus + '</button>' +
              '</div>' +
              '<button type="button" class="cart-item__remove" data-change="0" aria-label="Retirer">' + ICONS.trash + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-item__price"><strong>' + esc(formatMoney(item.final_line_price)) + '</strong>' + was + '</div>' +
        '</div>';
    }).join('');
  }

  function refreshCart() {
    return getCart().then(function (cart) { renderCart(cart); return cart; });
  }

  function openCart() {
    if (T.cartType === 'page' || !cartDrawer) { window.location.href = T.routes.cart || '/cart'; return; }
    openDrawer(cartDrawer, cartOverlay);
  }

  function changeLine(key, qty) {
    cartDrawer.classList.add('is-busy');
    return fetch((T.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || T.strings.error, true); return refreshCart(); }
        renderCart(res.data);
      })
      .catch(function () { toast(T.strings.error, true); })
      .finally(function () { cartDrawer.classList.remove('is-busy'); });
  }

  function initCart() {
    cartDrawer = $('[data-cart-drawer]');
    cartOverlay = $('[data-drawer-overlay]');

    if (cartDrawer && T.cartType !== 'page') {
      $$('[data-cart-open]').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); refreshCart().catch(function () {}); openCart(); });
      });
      $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { closeDrawer(cartDrawer, cartOverlay); }); });
      cartOverlay.addEventListener('click', function () { closeDrawer(cartDrawer, cartOverlay); });

      cartDrawer.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-change]');
        if (!btn) return;
        var row = btn.closest('[data-key]');
        changeLine(row.getAttribute('data-key'), parseInt(btn.getAttribute('data-change'), 10));
      });
      cartDrawer.addEventListener('change', function (e) {
        if (!e.target.matches('[data-change-input]')) return;
        var row = e.target.closest('[data-key]');
        changeLine(row.getAttribute('data-key'), parseInt(e.target.value, 10) || 0);
      });
      refreshCart().catch(function () {});
    }

    // Ajout au panier AJAX
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('js-ajax-cart')) return;
      if (T.cartType === 'page') return;
      e.preventDefault();
      var btns = $$('[type="submit"]', form);
      if (e.submitter && btns.indexOf(e.submitter) === -1) btns.push(e.submitter);
      btns.forEach(function (b) { b.classList.add('is-loading'); });

      fetch((T.routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.data.description || res.data.message || T.strings.error, true); return; }
          return refreshCart().then(function () { openCart(); });
        })
        .catch(function () { toast(T.strings.error, true); })
        .finally(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeDrawer(cartDrawer, cartOverlay);
      closeDrawer($('[data-menu-drawer]'), $('[data-menu-overlay]'));
    });
  }

  /* ---------- Quantité (+/-) ---------- */
  function initQty() {
    var timer;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-minus],[data-qty-plus]');
      if (!btn) return;
      var wrap = btn.closest('[data-qty]');
      var input = wrap && $('input', wrap);
      if (!input) return;
      var min = input.min !== '' ? parseInt(input.min, 10) : 1;
      var val = parseInt(input.value, 10) || 0;
      val = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(min, val - 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-auto-update]')) return;
      var form = e.target.form;
      clearTimeout(timer);
      timer = setTimeout(function () { if (form) form.submit(); }, 600);
    });
  }

  /* ---------- Heure de Paris ---------- */
  var parisFmt;
  function parisParts(date) {
    if (!parisFmt) {
      parisFmt = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      });
    }
    var o = {};
    parisFmt.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute, s: +o.second };
  }
  // Heure murale de Paris exprimée comme un timestamp "UTC"
  function parisWall(date) {
    var p = parisParts(date);
    return Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s);
  }
  // Convertit une date/heure de Paris en vrai timestamp
  function parisToUtc(y, m, d, h, mi) {
    var guess = Date.UTC(y, m - 1, d, h, mi, 0);
    var offset = parisWall(new Date(guess)) - guess;
    var utc = guess - offset;
    var offset2 = parisWall(new Date(utc)) - utc;
    return guess - offset2;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- Compte à rebours promo (date réelle) ---------- */
  function initCountdowns(scope) {
    $$('[data-countdown]', scope).forEach(function (el) {
      if (el._cd) clearInterval(el._cd);
      var raw = (el.getAttribute('data-countdown') || '').trim();
      var m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      var section = el.closest('[data-countdown-section]');
      if (!m) { el.innerHTML = '<p class="editor-note">Format de date invalide. Exemple : 2026-10-31 23:59</p>'; return; }
      var end = parisToUtc(+m[1], +m[2], +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59);
      var dEl = $('[data-d]', el), hEl = $('[data-h]', el), mEl = $('[data-m]', el), sEl = $('[data-s]', el);

      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          clearInterval(el._cd);
          if (section && section.getAttribute('data-hide-on-end') === 'true' && !window.Shopify?.designMode) {
            section.hidden = true;
          } else {
            el.hidden = true;
            var ended = section && $('[data-countdown-ended]', section);
            if (ended) ended.hidden = false;
          }
          return;
        }
        var s = Math.floor(diff / 1000);
        dEl.textContent = pad(Math.floor(s / 86400));
        hEl.textContent = pad(Math.floor((s % 86400) / 3600));
        mEl.textContent = pad(Math.floor((s % 3600) / 60));
        sEl.textContent = pad(s % 60);
      }
      tick();
      el._cd = setInterval(tick, 1000);
    });
  }

  /* ---------- Compte à rebours expédition ---------- */
  var DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  function initShipTimers(scope) {
    $$('[data-ship-timer]', scope).forEach(function (el) {
      if (el._st) clearInterval(el._st);
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
      var tpl = el.getAttribute('data-template') || 'Commandez dans [timer] pour une expédition [day]';
      var out = $('[data-ship-text]', el);

      function tick() {
        var now = parisWall(new Date());
        var n = new Date(now);
        var target = null, offDays = 0;
        for (var i = 0; i < 8; i++) {
          var c = Date.UTC(n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate() + i, cutoff, 0, 0);
          var dow = new Date(c).getUTCDay();
          if (dow >= 1 && dow <= 5 && c > now) { target = c; offDays = i; break; }
        }
        if (!target) return;
        var s = Math.floor((target - now) / 1000);
        var h = Math.floor(s / 3600), mi = Math.floor((s % 3600) / 60), sec = s % 60;
        var timer = (h > 0 ? h + 'h ' : '') + pad(mi) + 'min ' + pad(sec) + 's';
        var day = offDays === 0 ? "aujourd'hui" : offDays === 1 ? 'demain' : DAYS[new Date(target).getUTCDay()];
        out.innerHTML = esc(tpl)
          .replace('[timer]', '<strong>' + timer + '</strong>')
          .replace('[day]', '<strong>' + day + '</strong>');
      }
      tick();
      el._st = setInterval(tick, 1000);
    });
  }

  /* ---------- Fiche produit ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var picker = $('[data-variant-picker]', root);
    var idInput = $('[data-variant-input]', root);
    var stockEl = $('[data-stock]', root);
    var track = $('[data-gallery-track]', root);
    var thumbs = $$('[data-thumb]', root);
    var baseUrl = root.getAttribute('data-product-url');

    /* Galerie */
    function goTo(i) {
      if (!track) return;
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    }
    function currentIndex() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = currentIndex();
          thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        });
      }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.getAttribute('data-thumb')); }); });
      var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
      var count = $$('.gallery__slide', track).length;
      if (prev) prev.addEventListener('click', function () { goTo((currentIndex() - 1 + count) % count); });
      if (next) next.addEventListener('click', function () { goTo((currentIndex() + 1) % count); });
    }

    /* Stock */
    function renderStock(v) {
      if (!stockEl) return;
      var t = parseInt(stockEl.getAttribute('data-threshold'), 10) || 10;
      var line = $('[data-stock-text]', stockEl);
      var bar = $('[data-stock-bar]', stockEl);
      if (!v || !v.available) {
        line.className = 'stock__line stock__line--out';
        line.innerHTML = ICONS.close + '<span>' + esc(stockEl.getAttribute('data-out-text')) + '</span>';
        bar.hidden = true;
      } else if (v.managed && v.qty > 0 && v.qty <= t) {
        line.className = 'stock__line stock__line--low';
        line.innerHTML = ICONS.fire + '<span>' + esc(stockEl.getAttribute('data-low-text')).replace('[qty]', '<strong>' + v.qty + '</strong>') + '</span>';
        bar.hidden = false;
        var pct = Math.max(6, Math.min(100, Math.round((v.qty / t) * 100)));
        $('span', bar).style.width = pct + '%';
      } else {
        line.className = 'stock__line stock__line--in';
        line.innerHTML = '<span class="dot dot--pulse"></span><span>' + esc(stockEl.getAttribute('data-in-text')) + '</span>';
        bar.hidden = true;
      }
    }

    function setText(sel, txt) { $$(sel, root).forEach(function (el) { el.textContent = txt; }); }

    function update(v) {
      if (idInput) idInput.value = v ? v.id : '';
      var onSale = v && v.compare > v.price;
      if (v) {
        setText('[data-price]', formatMoney(v.price));
        setText('[data-sticky-price]', formatMoney(v.price));
      }
      $$('[data-price-wrap]', root).forEach(function (w) { w.classList.toggle('price--sale', !!onSale); });
      $$('[data-compare]', root).forEach(function (el) { el.hidden = !onSale; if (onSale) el.textContent = formatMoney(v.compare); });
      var pct = onSale ? Math.round(((v.compare - v.price) * 100) / v.compare) : 0;
      $$('[data-pct],[data-sale-badge]', root).forEach(function (el) { el.hidden = !onSale; if (onSale) el.textContent = '-' + pct + '%'; });
      $$('[data-saving-wrap]', root).forEach(function (el) { el.hidden = !onSale; });
      if (onSale) setText('[data-saving]', formatMoney(v.compare - v.price));

      var available = !!(v && v.available);
      var label = !v ? T.strings.unavailable : available ? T.strings.addToCart : T.strings.soldOut;
      $$('[data-atc],[data-sticky-btn]', root).forEach(function (b) {
        b.disabled = !available;
        var span = $('span', b) || b;
        span.textContent = label;
      });

      renderStock(v);

      if (v && v.media && track) {
        var slides = $$('.gallery__slide', track);
        slides.forEach(function (s, i) { if (+s.getAttribute('data-media-id') === v.media) goTo(i); });
      }
      if (v && baseUrl && window.history.replaceState) {
        window.history.replaceState({}, '', baseUrl + '?variant=' + v.id);
      }
    }

    if (picker) {
      var groups = $$('fieldset', picker);
      var selected = function () { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); };
      var find = function (opts) {
        for (var i = 0; i < data.variants.length; i++) {
          var v = data.variants[i], ok = true;
          for (var k = 0; k < opts.length; k++) { if (v.options[k] !== opts[k]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      };
      var markAvailability = function () {
        var sel = selected();
        groups.forEach(function (g, gi) {
          $$('input', g).forEach(function (input) {
            var opts = sel.slice(); opts[gi] = input.value;
            var v = find(opts);
            input.closest('.pill').classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      };
      picker.addEventListener('change', function (e) {
        var g = e.target.closest('fieldset');
        var lbl = g && $('[data-option-selected]', g);
        if (lbl) lbl.textContent = e.target.value;
        update(find(selected()));
        markAvailability();
      });
      markAvailability();
    }

    /* Barre d'achat fixe (mobile) */
    var sticky = $('[data-sticky-atc]', root);
    var atc = $('[data-atc]', root);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(atc);
    }
  }

  /* ---------- Recommandations ---------- */
  function initRecommendations(scope) {
    $$('[data-recommendations]', scope).forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.children.length) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = $('[data-recommendations]', tmp);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else el.hidden = true;
      }).catch(function () {});
    });
  }

  /* ---------- FAQ : une seule question ouverte ---------- */
  function initFaq() {
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('.faq__item') || !d.open) return;
      var list = d.closest('[data-single-open]');
      if (!list) return;
      $$('.faq__item', list).forEach(function (o) { if (o !== d) o.open = false; });
    }, true);
  }

  /* ---------- Filtres collection ---------- */
  function initFilters() {
    $$('[data-filter-form]').forEach(function (form) {
      function go() {
        var params = new URLSearchParams();
        new FormData(form).forEach(function (val, key) { if (String(val).trim() !== '') params.append(key, val); });
        window.location.href = form.getAttribute('action') + '?' + params.toString();
      }
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], select[data-auto-submit]')) go();
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); go(); });
      document.addEventListener('click', function (e) {
        $$('details.filter[open]', form).forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
      });
    });
  }

  /* ---------- Init ---------- */
  function initScope(scope) {
    $$('[data-product]', scope).forEach(initProduct);
    initCountdowns(scope);
    initShipTimers(scope);
    initRecommendations(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initCart();
    initQty();
    initFaq();
    initFilters();
    initScope(document);
  });

  // Éditeur de thème
  document.addEventListener('shopify:section:load', function (e) { initScope(e.target); });
})();
